
import { COVER_IMAGE_RATIO } from "@/appSettings";
import { Vue, Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import CreateSleepStoryViewModel from "@models/sleepStories/create/createSleepStoryViewModel";
import SleepStoryTranslateViewModel from "@models/sleepStories/create/sleepStoryTranslateViewModel";
import CategoryViewModel from "@models/categoryViewModel";

@Component
export default class CreateSleepStoryComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  isEditAudio = false;
  currentAudioGroup: AudioGroupViewModel = null;
  categories: CategoryViewModel[] = [];
  coverImageRatio = COVER_IMAGE_RATIO;
  errorMessage: string = "";
  @Watch('errorMessage')
  isValid(): boolean {
    const isValid = (this.$refs.validator as any).isValid();
    const isValidAudio = this.vm.audios.length > 0 ? true : false;
    if (!isValidAudio) {
      this.errorMessage = "*Лекция обязательна";
    } else {
      this.errorMessage = "";
    }
    if (isValid && isValidAudio) {
      return true;
    } else return false;
  }
  get title(): string {
    return this.id
      ? "Редактирование сонной истории"
      : "Добавление сонной истории";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateSleepStoryViewModel = new CreateSleepStoryViewModel();
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.translations = this.languages.map(
      (x) =>
        new SleepStoryTranslateViewModel({
          langCode: x,
        })
    );
    const catRes = await this.$api.SleepStoryService.getCategoriesAsync();
    this.categories = (catRes.Items || []).map((x) => new CategoryViewModel(x));
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.SleepStoryService.getSleepStoryAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    const isValid = this.isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.SleepStoryService.updateSleepStoryAsync(
      request
    );
    if (res) {
      this.$dialog.success("История для сна успешно обновлена");
      this.$router.back();
    }
    this.isLoading = false;
    this.isEditAudio = false;
  }
  audioGroupChanged(audioGroup: AudioGroupViewModel) {
    if (audioGroup == null) {
      this.currentAudioGroup = null;
      this.isEditAudio = false;
      return;
    }
    if (this.audioAddMode == "edit") {
      this.isEditAudio = false;
      Object.assign(this.currentAudioGroup, audioGroup);
    } else if (this.audioAddMode == "add") {
      this.isEditAudio = false;
      this.vm.audios.push(audioGroup);
    }
    this.currentAudioGroup == null;
    this.isValid();
  }
  audioAddMode: "edit" | "add" | null = null;
  startAddAudio() {
    this.currentAudioGroup = new AudioGroupViewModel(this.languages);
    this.audioAddMode = "add";
    this.isEditAudio = true;
  }
  startEditAudioGroup(item: AudioGroupViewModel) {
    this.currentAudioGroup = item;
    this.audioAddMode = "edit";
    this.isEditAudio = true;
  }
  deleteAudioGroup(item: AudioGroupViewModel) {
    this.vm.audios = this.vm.audios.filter((x) => x != item);
  }
}
